export default __webpack_public_path__ + "3ccec68b604b8c99cbfb4388eaffa8fa.jpg";